import { PropsWithChildren } from 'react'

import { useCreation } from 'ahooks'

import { MemberDeptUserStoreContext } from './contexts/StoreContext'
import { MemberDeptUserStoreProviderProps } from './interface'
import { createMemberDeptUserStore } from './store/createStore'
import { MemberDeptUserStoreUpdater } from './StoreUpdater'

export const MemberDeptUserStoreProvider = <M extends boolean>({
  children,
  /* -------------------------------------------------------------------------- */
  /*                       MemberDeptUserStoreUpdater Props                       */
  /* -------------------------------------------------------------------------- */
  memberId,
  deptId,
  multiple,
  value,
  onChange
}: PropsWithChildren<MemberDeptUserStoreProviderProps<M>>) => {
  const store = useCreation(() => createMemberDeptUserStore(), [])
  return (
    <MemberDeptUserStoreContext value={store}>
      <MemberDeptUserStoreUpdater
        deptId={deptId}
        memberId={memberId}
        multiple={multiple}
        value={value}
        onChange={onChange}
      />
      {children}
    </MemberDeptUserStoreContext>
  )
}
